// export default defineNuxtRouteMiddleware(async (to, _from) => {
//   const { token_expired, checkAutoRefresh } = useDirectusToken();

//   // Check if the token's expired
//   if (token_expired.value) {
//     try {
//       // Attempt to refresh the token
//       await checkAutoRefresh();
//       // If still expired, off to the login page
//       if (token_expired.value) {
//         return navigateTo('/login');
//       }
//     } catch (error) {
//       // Handle any refresh errors here
//       console.error("Couldn't refresh token:", error);
//     }
//   }
//   // If the token's good, carry on
//  });
export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.meta?.requiresAuth) return;
  const { $isAuthenticated } = useNuxtApp();
  const me = await $isAuthenticated();
  // try refresh
  const { $refreshToken } = useNuxtApp();
  if (!me) {
    try {
      await $refreshToken();
    } catch (error) {
      // If refresh fails, redirect to login
      return navigateTo(`/login?redirect=${encodeURIComponent(to.fullPath)}`);
    }
  }
  // console.log('Auth middleware:', { me, requiresAuth: to.meta.requiresAuth });
  if (!me) return navigateTo(`/login?redirect=${encodeURIComponent(to.fullPath)}`);
});
